import { useDeals } from '@finn/platform-modules';
import dayjs from 'dayjs';
import { useMemo } from 'react';

const MAX_DAYS_BEFORE_RETURN = 121;
const MIN_DAYS_BEFORE_RETURN = 14;

export const useReadyForRetentionDeals = () => {
  const { activeDeals, dealsStatus } = useDeals();

  // copying the logic in visibility config of this cosmic object used in CP -> 6784d8a75ecdabfe037a9b42
  const activeSubscriptions = useMemo(
    () =>
      activeDeals?.filter((deal) => {
        const isSubscribedTo = ['SWAP_SAME_DAY', 'PROLONGATION'].includes(
          deal.subscribed_to
        );
        if (isSubscribedTo) {
          return false;
        }
        const endDate = dayjs(deal.return_date || deal.end_date);

        return (
          endDate.isAfter(dayjs().add(MIN_DAYS_BEFORE_RETURN, 'day')) &&
          endDate.isBefore(dayjs().add(MAX_DAYS_BEFORE_RETURN, 'day'))
        );
      }),
    [activeDeals]
  );

  return { activeSubscriptions, dealsStatus };
};
